export function isMobileViewport(viewportWidth?: number): boolean {
    return (viewportWidth ?? window.outerWidth) < +getComputedStyle(document.documentElement)
        .getPropertyValue('--bs-grid-breakpoint-md')
        .replace(/[^\d.]+?/gim, '');
}
